import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

/** Color del borde y el fondo del título: `alerta` (amarillo) para lo que está en curso, `exito` (verde) para lo cerrado. */
export type DesplegableTono = "neutro" | "alerta" | "exito";

const BORDE: Record<DesplegableTono, string> = { neutro: "border-borde", alerta: "border-alerta", exito: "border-exito" };
const TITULO: Record<DesplegableTono, string> = { neutro: "", alerta: "rounded-tarjeta bg-alerta-suave group-open:rounded-b-none", exito: "rounded-tarjeta bg-exito-suave group-open:rounded-b-none" };

export interface DesplegableProps {
  titulo: ReactNode;
  abiertoInicial?: boolean;
  /** Se llama con `true`/`false` cada vez que el usuario lo abre o lo cierra (para recordar la elección). */
  onCambio?: (abierto: boolean) => void;
  tono?: DesplegableTono;
  className?: string;
  children: ReactNode;
}

/** Bloque que se abre y cierra (details/summary nativo: accesible por teclado sin JS). */
export function Desplegable({ titulo, abiertoInicial = false, onCambio, tono = "neutro", className, children }: DesplegableProps) {
  return (
    <details open={abiertoInicial} onToggle={(e) => onCambio?.(e.currentTarget.open)} className={cn("group rounded-tarjeta border bg-superficie shadow-tarjeta", BORDE[tono], className)}>
      <summary className={cn("flex min-h-11 cursor-pointer list-none items-center justify-between gap-3 px-4 py-3 font-medium [&::-webkit-details-marker]:hidden", TITULO[tono])}>
        <span>{titulo}</span>
        <span aria-hidden className="text-texto-suave transition-transform group-open:rotate-180">
          ▾
        </span>
      </summary>
      <div className="border-t border-borde p-4">{children}</div>
    </details>
  );
}
